import { invoicesApi } from "@web-src/features/api/createApi";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";

export const useInvoicesConfigList = () => {
  const { entity } = useEntitySelectedProvider();
  const { data, isLoading, error, refetch } = invoicesApi.useGetConfigListQuery(
    {
      entityId: entity.id,
    }
  );

  return {
    data,
    isLoading,
    error,
    configId: data?.data?.at(-1)?.id || "",
    refetch,
  };
};
